import React from 'react';
import { PopularHotelsDestinationsDesktop } from './PopularHotelsDestinationsDesktop';
import { Config, LocationUtils } from '../../utils';
import { EntryPoint } from '../../models';

export function PopularHotelsDestinationsSourceDesktop() {
    return {
        render: ({ onClickItem, displayedWord = '' } = {}) => {
            const show = !LocationUtils.isKeywordLongEnoughAccordingWithLanguage(
                displayedWord,
                Config.get('autocompleteOptions'),
                EntryPoint.HOTELS
            );
            return (
                <PopularHotelsDestinationsDesktop
                    key="top-destinations"
                    onClickItem={onClickItem}
                    show={show}
                />
            );
        },
    };
}
